/** @format */
import angular from 'angular';
import { calendarEventServiceModule } from 'sis-components/calendar/calendarEvent.service';
import { calendarSettingsModalServiceModule } from 'sis-components/calendar/dialog/calendarSettingsModal.service';
import { enrolmentModalServiceModule } from '../common/components/course-unit-realisation/enrolment/enrolmentModal.service';
export const studentCalendarModule = 'student.calendar';

/**
 * This contains the remaining AngularJS dependencies needed for the student calendar since the root component is now in Angular.
 */
(function () {
  angular.module(studentCalendarModule, [calendarSettingsModalServiceModule, calendarEventServiceModule, enrolmentModalServiceModule]);
})();